// extracted by mini-css-extract-plugin
export default {"badge":"list_badge__-BSyy","blue":"list_blue__9pq7k","green":"list_green__aTsOX","orange":"list_orange__i0MJw","red":"list_red__5CVY1"};